import React from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Spinner = ({ className }) => {
  return <FontAwesomeIcon icon={faSpinner} className={className} spin />;
};

export default Spinner;